import * as React from 'react';

export const header = {
  heading: 'Security'
};
export const richText1 = {
  id: 'Security',
  html:
    '                <p>When you place orders on our websites or through our mobile applications, all of \n'
    + '                 your order information, including your credit card number and delivery address, is transmitted \n'
    + '                 through the Internet using Secure Sockets Layer (SSL) technology. SSL technology causes \n'
    + '                 your browser to encrypt your order information before transmitting it to our secure server.\n'
    + '                 SSL technology, an industry standard, is designed to prevent someone other than operators \n'
    + '                 of our websites from capturing and viewing your personal information. </p> \n'
    + '                <p><br/></p> \n'
    + '              <p> While we use industry standard means to protect our websites and your information, \n'
    + '                  the Internet is not 100% secure. The measures we use are appropriate for the type of information\n'
    + '                  we collect. We cannot promise that your use of our websites or mobile applications will be \n'
    + '                  completely safe. We encourage you to use caution when using the Internet. Online access to \n'
    + '                  your personal information is protected with a password you select. We strongly recommend \n'
    + '                  that you do not share your password and that you use unique passwords for all of \n'
    + '                  your online accounts</p>\n'

};
